import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Building2,
  Store,
  Sparkles,
  Server,
  Briefcase,
  Hotel,
  GraduationCap,
  Warehouse,
  Factory,
  Utensils,
  Home as HomeIcon,
  Armchair,
  SlidersHorizontal,
  Layers,
  ShieldCheck,
  Activity,
  Phone,
  MessageSquare,
  MapPin,
  Clock,
  CheckCircle2,
  Calendar,
  User,
  Check,
  Star,
  ChevronRight,
  Menu,
  X,
  Shield,
  Award,
  Users
} from "lucide-react";
import { Toaster, toast } from "sonner";

// Logo from provided artwork
const LOGO_URL = "/logo.png";
const WHATSAPP_NUMBER = "+919686171995";
const DISPLAY_PHONE = "+91 96861 71995 | 8970007671";
const ADDRESS = "No. 18, Ground Floor, 2nd Cross, 2nd A Main Road, Near Ann Maria School, Bhuvaneshwari Nagar, R.T. Nagar, Bengaluru, Karnataka 560032, India";

const SERVICES_LIST = [
  {
    id: "corporate-office-cleaning",
    title: "Corporate Office Cleaning",
    short_desc: "Daily and contractual cleaning for corporate offices, boardrooms, workstations and executive cabins across Bangalore.",
    icon: Building2,
    category: "Office",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "commercial-space-cleaning",
    title: "Commercial Space Cleaning",
    short_desc: "End-to-end cleaning solutions for commercial buildings, showrooms and multi-tenant office spaces with tailored schedules.",
    icon: Store,
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1698822457446-ac18737a2ac4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "deep-office-cleaning",
    title: "Deep Office Cleaning",
    short_desc: "Bangalore's most requested deep office cleaning service — chairs, carpets, workstations, ducts, glass and washrooms.",
    icon: Sparkles,
    category: "Deep Clean",
    image: "https://images.pexels.com/photos/36631699/pexels-photo-36631699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "it-office-cleaning",
    title: "IT Office Cleaning",
    short_desc: "Specialised cleaning for IT companies and software parks with anti-static, screen and server-room safe protocols.",
    icon: Server,
    category: "Tech",
    image: "https://images.unsplash.com/photo-1746021375258-79fa1464ca1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwZmxvb3IlMjBzY3J1YmJpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "business-park-cleaning",
    title: "Business Park Cleaning",
    short_desc: "Common areas, lobbies, elevators, cafeterias and washroom housekeeping for large business parks and campuses.",
    icon: Briefcase,
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1780369088190-914cc3eee938?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwZmxvb3IlMjBzY3J1YmJpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "hotel-cleaning",
    title: "Hotel Cleaning",
    short_desc: "Hospitality-grade housekeeping, room cleaning, banquet and back-of-house cleaning for hotels and serviced apartments.",
    icon: Hotel,
    category: "Hospitality",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "school-cleaning",
    title: "School Cleaning",
    short_desc: "Child-safe, non-toxic school cleaning covering classrooms, labs, corridors, canteens and washrooms.",
    icon: GraduationCap,
    category: "Institutional",
    image: "https://images.unsplash.com/photo-1613230902235-eefb7a1cdc48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "warehouse-cleaning",
    title: "Warehouse Cleaning",
    short_desc: "Large-scale warehouse cleaning with ride-on scrubbers, high-reach dusting and pallet-area sanitisation.",
    icon: Warehouse,
    category: "Industrial",
    image: "https://images.unsplash.com/photo-1780369088190-914cc3eee938?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjb3Jwb3JjaWFsJTIwZmxvb3IlMjBzY3J1YmJpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "factory-plant-cleaning",
    title: "Factory & Plant Cleaning",
    short_desc: "Industrial cleaning services for factories and manufacturing plants, machinery cleaning and hazard-zone housekeeping.",
    icon: Factory,
    category: "Industrial",
    image: "https://images.unsplash.com/photo-1746021375258-79fa1464ca1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxjb3Jwb3JjaWFsJTIwZmxvb3IlMjBzY3J1YmJpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "cafe-restaurant-cleaning",
    title: "Cafe & Restaurant Cleaning",
    short_desc: "FSSAI-friendly kitchen, dining and grease-trap cleaning for cafes, restaurants and corporate cafeterias.",
    icon: Utensils,
    category: "Hospitality",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "pg-accommodation-cleaning",
    title: "PG Accommodation Cleaning",
    short_desc: "Contractual cleaning and housekeeping for PGs, hostels and co-living spaces including rooms and common areas.",
    icon: HomeIcon,
    category: "Residential",
    image: "https://images.unsplash.com/photo-1772001936267-b6058748eff4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxjb3Jwb3JjaWFsJTIwZmxvb3IlMjBzY3J1YmJpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "office-chair-cleaning",
    title: "Office Chair Cleaning",
    short_desc: "Corporate chair shampooing and fabric extraction cleaning for offices with 100+ workstations.",
    icon: Armchair,
    category: "Specialised",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "floor-scrubbing",
    title: "Floor Scrubbing",
    short_desc: "Machine floor scrubbing, polishing and crystallisation for marble, vitrified, granite and epoxy floors.",
    icon: SlidersHorizontal,
    category: "Specialised",
    image: "https://images.unsplash.com/photo-1779345169505-be7319f62b97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxjb3Jwb3JjaWFsJTIwZmxvb3IlMjBzY3J1YmJpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "glass-facade-cleaning",
    title: "Glass & Facade Cleaning",
    short_desc: "Internal and external glass cleaning for cabins, partitions and low-rise facades with streak-free finish.",
    icon: Layers,
    category: "Specialised",
    image: "https://images.unsplash.com/photo-1761641428582-b85a085340d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxnbGFzcyUyMGZhY2FkZSUyMGNsZWFuaW5nJTIwYnVpbGRpbmclMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg3NTkxNzY4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "washroom-sanitization",
    title: "Washroom Sanitization",
    short_desc: "Deep washroom sanitisation, descaling, odour control and periodic fogging for corporate restrooms.",
    icon: ShieldCheck,
    category: "Sanitisation",
    image: "https://images.unsplash.com/photo-1698822457446-ac18737a2ac4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "high-touch-disinfection",
    title: "High-Touch Disinfection",
    short_desc: "Hospital-grade disinfection of desks, door handles, lifts and shared surfaces to reduce workplace germs.",
    icon: Activity,
    category: "Sanitisation",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85"
  }
];

export default function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  // Booking Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeService, setActiveService] = useState(SERVICES_LIST[0]);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [preferredDate, setPreferredDate] = useState("");
  const [propertySize, setPropertySize] = useState("Medium Office (2,000 - 5,000 sq.ft)");
  const [notes, setNotes] = useState("");

  const handleOpenBooking = (service) => {
    setActiveService(service);
    setIsModalOpen(true);
  };

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();
    if (!customerName || !customerPhone || !preferredDate) {
      toast.error("Please fill in Name, Phone Number, and Preferred Date.");
      return;
    }

    const message = `Hello NEXA Cleaning Services,\n\nI would like to book / enquire about the following service:\nService: ${activeService.title}\nCustomer Name: ${customerName}\nPhone: ${customerPhone}\nPreferred Date: ${preferredDate}\nProperty Size: ${propertySize}\nAdditional Notes: ${notes || "None"}\n\nPlease confirm availability.`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=${encodeURIComponent(message)}`;
    
    toast.success("Redirecting to WhatsApp with your booking details!");
    setTimeout(() => {
      window.open(whatsappUrl, "_blank");
      setIsModalOpen(false);
    }, 600);
  };

  const filteredServices = SERVICES_LIST.filter(item => {
    const matchesCategory = selectedCategory === "All" || item.category === selectedCategory;
    const matchesSearch = item.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
                          item.short_desc.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 font-sans selection:bg-red-600 selection:text-white">
      <Toaster position="top-center" richColors />

      {/* TOP NOTIFICATION BAR */}
      <div className="bg-gradient-to-r from-red-700 via-red-600 to-slate-900 text-white text-xs sm:text-sm py-2 px-4 text-center font-medium tracking-wide flex items-center justify-center gap-3">
        <span className="bg-black/30 px-2 py-0.5 rounded text-xs font-bold uppercase tracking-wider">Bangalore Express</span>
        <span>Corporate Cleaning Experts in RT Nagar, Hebbal, Electronic City & Whitefield</span>
        <a 
          href={`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=Hello%20NEXA,%20I%20need%20urgent%20corporate%20cleaning%20service`} 
          target="_blank" 
          rel="noreferrer"
          className="underline hover:text-red-200 hidden md:inline font-semibold"
          data-testid="topbar-whatsapp-link"
        >
          Chat on WhatsApp +91 96861 71995
        </a>
      </div>

      {/* HEADER / NAVBAR */}
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800 transition-all">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          
          {/* LOGO & BRAND */}
          <a href="#" className="flex flex-col items-center justify-center text-center gap-0.5 group" data-testid="brand-logo-link">
            <div className="h-10 sm:h-11 flex items-center justify-center w-full">
              <img 
                src={LOGO_URL} 
                alt="NEXA Logo" 
                className="h-full w-auto object-contain group-hover:scale-105 transition-transform duration-300 mx-auto" 
              />
            </div>
            <div className="flex flex-col items-center justify-center w-full max-w-[210px]">
              <div className="flex items-center justify-center gap-1.5 text-white font-extrabold text-[9px] sm:text-[10px] tracking-wider uppercase whitespace-nowrap">
                <span className="w-3 sm:w-4 h-[2px] bg-red-600 rounded-full inline-block"></span>
                <span>DEEP CLEANING SERVICES</span>
                <span className="w-3 sm:w-4 h-[2px] bg-red-600 rounded-full inline-block"></span>
              </div>
              <div className="text-[7.5px] sm:text-[8.5px] font-bold text-red-500 tracking-[0.18em] uppercase text-center mt-[1px] whitespace-nowrap">
                CLEANER SPACES. BETTER LIVING.
              </div>
            </div>
          </a>

          {/* DESKTOP NAV LINKS */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-300">
            <a href="#services" className="hover:text-red-400 transition-colors" data-testid="nav-services">Services (16)</a>
            <a href="#why-nexa" className="hover:text-red-400 transition-colors" data-testid="nav-why-nexa">Why NEXA</a>
            <a href="#coverage" className="hover:text-red-400 transition-colors" data-testid="nav-coverage">Bangalore Hubs</a>
            <a href="#contact" className="hover:text-red-400 transition-colors" data-testid="nav-contact">Contact</a>
          </nav>

          {/* RIGHT ACTION */}
          <div className="hidden sm:flex items-center gap-4">
            <a 
              href={`tel:${WHATSAPP_NUMBER}`}
              className="text-xs text-slate-400 hover:text-white flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-800 bg-slate-900/50"
              data-testid="header-phone-btn"
            >
              <Phone className="w-3.5 h-3.5 text-red-500" />
              <span className="font-semibold text-slate-200">+91 96861 71995</span>
            </a>
            <button
              onClick={() => handleOpenBooking(SERVICES_LIST[0])}
              className="bg-red-600 hover:bg-red-500 text-white font-semibold text-sm px-5 py-2.5 rounded-xl shadow-[0_4px_20px_rgba(220,38,38,0.4)] hover:shadow-[0_6px_25px_rgba(220,38,38,0.6)] transition-all flex items-center gap-2 transform active:scale-95"
              data-testid="header-book-whatsapp-btn"
            >
              <MessageSquare className="w-4 h-4 fill-white" />
              <span>Book via WhatsApp</span>
            </button>
          </div>

          {/* MOBILE MENU BUTTON */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg bg-slate-900 border border-slate-800 text-slate-300 hover:text-white"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </header>

      {/* MOBILE MENU DROPDOWN */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-slate-950 border-b border-slate-800 px-6 py-6 space-y-4 shadow-2xl"
            data-testid="mobile-menu-dropdown"
          >
            <nav className="flex flex-col space-y-3 font-medium text-slate-200">
              <a 
                href="#services" 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-red-400 py-2 border-b border-slate-900"
                data-testid="mobile-nav-services"
              >
                Services (16)
              </a>
              <a 
                href="#why-nexa" 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-red-400 py-2 border-b border-slate-900"
                data-testid="mobile-nav-why-nexa"
              >
                Why NEXA
              </a>
              <a 
                href="#coverage" 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-red-400 py-2 border-b border-slate-900"
                data-testid="mobile-nav-coverage"
              >
                Bangalore Hubs
              </a>
              <a 
                href="#contact" 
                onClick={() => setMobileMenuOpen(false)}
                className="hover:text-red-400 py-2 border-b border-slate-900"
                data-testid="mobile-nav-contact"
              >
                Contact & Address
              </a>
            </nav>
            <div className="pt-2">
              <button
                onClick={() => { setMobileMenuOpen(false); handleOpenBooking(SERVICES_LIST[0]); }}
                className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-3 rounded-xl shadow-lg flex items-center justify-center gap-2"
                data-testid="mobile-book-btn"
              >
                <MessageSquare className="w-4 h-4 fill-white" />
                <span>Book via WhatsApp</span>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* HERO SECTION */}
      <section className="relative overflow-hidden pt-12 pb-24 lg:pt-20 lg:pb-32 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
        {/* Background ambient lighting */}
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-red-600/10 blur-[140px] pointer-events-none rounded-full" />
        <div className="absolute top-1/2 right-10 w-[300px] h-[300px] bg-blue-600/10 blur-[120px] pointer-events-none rounded-full" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            <div className="lg:col-span-7 space-y-6 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 px-3 py-1.5 rounded-full text-red-400 text-xs font-semibold tracking-wide uppercase">
                <Sparkles className="w-3.5 h-3.5 text-red-500 animate-spin" />
                <span>Bangalore&apos;s #1 Corporate Cleaning Provider</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.15]">
                Pristine Workspaces. <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-rose-500 to-red-400">
                  Zero Operational Friction.
                </span>
              </h1>

              <p className="text-base sm:text-lg text-slate-300 max-w-2xl mx-auto lg:mx-0 font-normal leading-relaxed">
                Daily and contractual commercial cleaning, glass facades, floor scrubbing, and deep sanitisation for corporate offices, IT parks, and multi-tenant campuses across Bangalore.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4">
                <button
                  onClick={() => handleOpenBooking(SERVICES_LIST[0])}
                  className="w-full sm:w-auto bg-red-600 hover:bg-red-500 text-white font-bold px-8 py-4 rounded-xl shadow-[0_8px_30px_rgba(220,38,38,0.4)] transition-all flex items-center justify-center gap-3 transform hover:-translate-y-0.5 active:translate-y-0"
                  data-testid="hero-primary-whatsapp-btn"
                >
                  <MessageSquare className="w-5 h-5 fill-white" />
                  <span>Book Service on WhatsApp</span>
                </button>
                <a
                  href="#services"
                  className="w-full sm:w-auto bg-slate-900 hover:bg-slate-800 text-slate-200 border border-slate-800 font-semibold px-6 py-4 rounded-xl transition-all flex items-center justify-center gap-2"
                  data-testid="hero-explore-services-btn"
                >
                  <span>Explore All 16 Services</span>
                  <ChevronRight className="w-4 h-4 text-red-500" />
                </a>
              </div>

              {/* TRUST METRICS */}
              <div className="grid grid-cols-3 gap-4 pt-8 border-t border-slate-800/80 max-w-lg mx-auto lg:mx-0">
                <div>
                  <div className="text-2xl sm:text-3xl font-black text-white">16+</div>
                  <div className="text-xs text-slate-400 mt-0.5 font-medium">Specialized Verticals</div>
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-black text-white">500+</div>
                  <div className="text-xs text-slate-400 mt-0.5 font-medium">Offices Cleaned</div>
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-black text-red-500 flex items-center justify-center lg:justify-start gap-1">
                    <span>4.9</span> <Star className="w-4 h-4 fill-red-500 text-red-500" />
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5 font-medium">Bangalore Rating</div>
                </div>
              </div>

            </div>

            {/* HERO RIGHT VISUAL */}
            <div className="lg:col-span-5 relative">
              <div className="relative mx-auto max-w-md lg:max-w-none rounded-2xl overflow-hidden border border-slate-800 shadow-[0_20px_60px_rgba(0,0,0,0.8)] bg-slate-900 group">
                <img 
                  src="https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODc1OTE3Njh8MA&ixlib=rb-4.1.0&q=85" 
                  alt="Corporate Office Cleaning Bangalore"
                  className="w-full h-[400px] object-cover group-hover:scale-105 transition-transform duration-700 opacity-90"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
                
                {/* Floating badge inside image */}
                <div className="absolute bottom-6 left-6 right-6 bg-slate-900/90 backdrop-blur-md p-4 rounded-xl border border-slate-700/60 shadow-xl flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-red-600/20 border border-red-500/40 flex items-center justify-center text-red-500 font-bold">
                      <ShieldCheck className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-white">Verified Uniformed Crew</h4>
                      <p className="text-xs text-slate-400">Background Checked & Insured</p>
                    </div>
                  </div>
                  <span className="text-xs bg-red-600 text-white font-bold px-2.5 py-1 rounded-full">RT Nagar Hub</span>
                </div>
              </div>

              {/* Decorative accent element */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-red-600/20 rounded-full blur-2xl pointer-events-none" />
            </div>

          </div>
        </div>
      </section>

      {/* SERVICES SECTION - ALL 16 SERVICES */}
      <section id="services" className="py-24 bg-slate-900/60 border-t border-slate-800/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
            <div>
              <div className="text-xs uppercase tracking-widest text-red-500 font-bold mb-2">Comprehensive Catalogue</div>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                All 16 Specialized Cleaning Verticals
              </h2>
              <p className="text-slate-400 text-base mt-2 max-w-xl">
                Select your required corporate or commercial service below and instantly dispatch your booking request directly to our WhatsApp dispatch desk (+91 96861 71995).
              </p>
            </div>

            {/* CATEGORY FILTER PILLS */}
            <div className="flex flex-wrap gap-2">
              {["All", "Office", "Commercial", "Deep Clean", "Tech", "Hospitality", "Industrial", "Sanitisation", "Specialised"].map((cat) => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`text-xs font-semibold px-4 py-2 rounded-xl transition-all ${
                    selectedCategory === cat 
                      ? "bg-red-600 text-white shadow-[0_0_15px_rgba(220,38,38,0.4)]" 
                      : "bg-slate-900 text-slate-400 border border-slate-800 hover:text-white hover:bg-slate-800"
                  }`}
                  data-testid={`category-filter-${cat.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* SEARCH INPUT */}
          <div className="mb-10 max-w-md">
            <input 
              type="text"
              placeholder="Search specific cleaning service (e.g., Chair, Glass, IT, Floor)..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-red-500 transition-colors"
              data-testid="services-search-input"
            />
          </div>

          {/* SERVICES GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredServices.map((service, idx) => {
              const IconComponent = service.icon || Building2;
              return (
                <motion.div
                  key={service.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: idx * 0.04 }}
                  className="bg-slate-950 rounded-2xl border border-slate-800/80 overflow-hidden flex flex-col justify-between hover:border-red-500/50 hover:shadow-[0_10px_30px_rgba(220,38,38,0.15)] transition-all group"
                  data-testid={`service-card-${service.id}`}
                >
                  <div>
                    {/* Service Image Banner */}
                    <div className="relative h-44 overflow-hidden bg-slate-900">
                      <img 
                        src={service.image} 
                        alt={service.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 opacity-80"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/20 to-transparent" />
                      
                      <div className="absolute top-3 left-3 bg-slate-900/80 backdrop-blur-md px-2.5 py-1 rounded-lg border border-slate-700/50 flex items-center gap-1.5 text-red-400 text-xs font-semibold">
                        <IconComponent className="w-3.5 h-3.5 text-red-500" />
                        <span>{service.category}</span>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-5 space-y-2">
                      <h3 className="text-lg font-bold text-white group-hover:text-red-400 transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-xs text-slate-400 leading-relaxed line-clamp-3">
                        {service.short_desc}
                      </p>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="p-5 pt-0 mt-auto border-t border-slate-900 pt-4">
                    <button
                      onClick={() => handleOpenBooking(service)}
                      className="w-full bg-red-600/90 hover:bg-red-600 text-white font-semibold text-xs py-2.5 px-4 rounded-xl shadow-md transition-all flex items-center justify-center gap-2 group-hover:shadow-[0_4px_15px_rgba(220,38,38,0.4)]"
                      data-testid={`book-service-${service.id}`}
                    >
                      <MessageSquare className="w-3.5 h-3.5 fill-white" />
                      <span>Book Now (WhatsApp)</span>
                    </button>
                  </div>

                </motion.div>
              );
            })}
          </div>

          {filteredServices.length === 0 && (
            <div className="text-center py-20">
              <p className="text-slate-400 text-base">No cleaning services found matching &quot;{searchQuery}&quot;.</p>
              <button 
                onClick={() => { setSearchQuery(""); setSelectedCategory("All"); }}
                className="mt-4 text-xs font-bold text-red-500 underline"
                data-testid="reset-service-filters"
              >
                Reset filters
              </button>
            </div>
          )}

        </div>
      </section>

      {/* WHY NEXA - 5 COLOUR / DESIGN RULES & TRUST SECTION */}
      <section id="why-nexa" className="py-24 bg-slate-950 border-t border-slate-800/80 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 px-3 py-1 rounded-full text-red-400 text-xs font-semibold uppercase tracking-wider">
              Institutional Excellence
            </div>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
              Why Bangalore&apos;s Top Corporations Trust NEXA
            </h2>
            <p className="text-slate-400 text-base">
              Built for high-standard corporate offices, IT parks, and multi-tenant campuses with rigid hygiene benchmarks.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            <div className="bg-slate-900/80 border border-slate-800 p-8 rounded-2xl space-y-4 hover:border-red-500/40 transition-all">
              <div className="w-12 h-12 rounded-xl bg-red-600/20 border border-red-500/40 flex items-center justify-center text-red-500">
                <Shield className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white">Zero-Disruption SLA</h3>
              <p className="text-sm text-slate-400 leading-relaxed">
                Our uniformed cleaning specialists operate on flexible shifts (early morning, late evening, or weekend slots) so your boardroom and workstations remain pristine without interrupting business hours.
              </p>
            </div>

            <div className="bg-slate-900/80 border border-slate-800 p-8 rounded-2xl space-y-4 hover:border-red-500/40 transition-all">
              <div className="w-12 h-12 rounded-xl bg-red-600/20 border border-red-500/40 flex items-center justify-center text-red-500">
                <Award className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white">Eco-Safe Industrial Chemicals</h3>
              <p className="text-sm text-slate-400 leading-relaxed">
                We use hospital-grade disinfectants and FSSAI-friendly cleaning agents that are tough on germs, stains, and grease yet completely safe for employees, IT servers, and school children.
              </p>
            </div>

            <div className="bg-slate-900/80 border border-slate-800 p-8 rounded-2xl space-y-4 hover:border-red-500/40 transition-all">
              <div className="w-12 h-12 rounded-xl bg-red-600/20 border border-red-500/40 flex items-center justify-center text-red-500">
                <Users className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white">Instant WhatsApp Dispatch</h3>
              <p className="text-sm text-slate-400 leading-relaxed">
                No complex forms or waiting for callbacks. Click any Book Now button to instantly prefill your custom cleaning request and connect directly with our RT Nagar dispatch desk on WhatsApp.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* BANGALORE SERVICE HUBS & ADDRESS SECTION */}
      <section id="coverage" className="py-20 bg-slate-900/40 border-t border-slate-800/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 px-3 py-1 rounded-full text-red-400 text-xs font-semibold uppercase tracking-wider">
                Headquarters & Coverage
              </div>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                Serving All Bangalore Tech Parks & Commercial Zones
              </h2>
              <p className="text-slate-300 text-sm leading-relaxed">
                Headquartered in RT Nagar, our rapid response teams are stationed across Hebbal, Indiranagar, Electronic City, Whitefield, MG Road, Manyata Tech Park, and Outer Ring Road.
              </p>

              <div className="space-y-4 pt-2">
                <div className="flex items-start gap-3 bg-slate-950 p-4 rounded-xl border border-slate-800">
                  <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-sm font-bold text-white">Registered Office Address</h4>
                    <p className="text-xs text-slate-400 mt-1 leading-relaxed">
                      {ADDRESS}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-slate-950 p-4 rounded-xl border border-slate-800">
                  <Phone className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-sm font-bold text-white">Direct Dispatch Lines</h4>
                    <p className="text-xs text-slate-400 mt-1 font-mono">
                      +91 96861 71995 | 8970007671
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* QUICK WHATSAPP INQUIRY CARD */}
            <div className="bg-slate-950 p-8 rounded-3xl border border-slate-800 shadow-2xl relative">
              <div className="absolute top-0 right-0 transform translate-x-2 -translate-y-2 bg-red-600 text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-lg">
                Quick Dispatch
              </div>

              <h3 className="text-xl font-bold text-white mb-2">Need an Urgent Quote?</h3>
              <p className="text-xs text-slate-400 mb-6">
                Send your office size and requirements directly to our WhatsApp number for an immediate estimate.
              </p>

              <form onSubmit={handleWhatsAppSubmit} className="space-y-4" data-testid="quick-whatsapp-form">
                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">Your Name / Company</label>
                  <input 
                    type="text" 
                    placeholder="e.g. Rajesh Kumar (TechPark Corp)"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    className="w-full bg-slate-900 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-red-500"
                    data-testid="quick-form-name"
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">WhatsApp Phone Number</label>
                  <input 
                    type="tel" 
                    placeholder="+91 98765 43210"
                    value={customerPhone}
                    onChange={(e) => setCustomerPhone(e.target.value)}
                    className="w-full bg-slate-900 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-red-500"
                    data-testid="quick-form-phone"
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">Preferred Date</label>
                  <input 
                    type="date" 
                    value={preferredDate}
                    onChange={(e) => setPreferredDate(e.target.value)}
                    className="w-full bg-slate-900 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-red-500"
                    data-testid="quick-form-date"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-3.5 rounded-xl shadow-[0_4px_20px_rgba(220,38,38,0.4)] transition-all flex items-center justify-center gap-2"
                  data-testid="quick-form-submit-whatsapp"
                >
                  <MessageSquare className="w-4 h-4 fill-white" />
                  <span>Send Request to WhatsApp (+91 96861 71995)</span>
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer id="contact" className="bg-slate-950 border-t border-slate-800 pt-16 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            
            <div className="space-y-4 md:col-span-1">
              <a href="#" className="flex flex-col items-center justify-center text-center gap-0.5 group">
                <div className="h-10 sm:h-11 flex items-center justify-center w-full">
                  <img 
                    src={LOGO_URL} 
                    alt="NEXA Logo" 
                    className="h-full w-auto object-contain group-hover:scale-105 transition-transform duration-300 mx-auto" 
                  />
                </div>
                <div className="flex flex-col items-center justify-center w-full max-w-[210px]">
                  <div className="flex items-center justify-center gap-1.5 text-white font-extrabold text-[9px] sm:text-[10px] tracking-wider uppercase whitespace-nowrap">
                    <span className="w-3 sm:w-4 h-[2px] bg-red-600 rounded-full inline-block"></span>
                    <span>DEEP CLEANING SERVICES</span>
                    <span className="w-3 sm:w-4 h-[2px] bg-red-600 rounded-full inline-block"></span>
                  </div>
                  <div className="text-[7.5px] sm:text-[8.5px] font-bold text-red-500 tracking-[0.18em] uppercase text-center mt-[1px] whitespace-nowrap">
                    CLEANER SPACES. BETTER LIVING.
                  </div>
                </div>
              </a>
              <p className="text-xs text-slate-400 leading-relaxed">
                Bangalore&apos;s premier commercial and corporate cleaning service provider. Delivering uncompromised hygiene and professional SLAs.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Quick Links</h4>
              <ul className="space-y-2.5 text-xs text-slate-400">
                <li><a href="#services" className="hover:text-white transition-colors">All 16 Services</a></li>
                <li><a href="#why-nexa" className="hover:text-white transition-colors">Why NEXA</a></li>
                <li><a href="#coverage" className="hover:text-white transition-colors">Bangalore Hubs</a></li>
                <li><a href="#contact" className="hover:text-white transition-colors">Contact & Address</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Popular Verticals</h4>
              <ul className="space-y-2.5 text-xs text-slate-400">
                <li><a href="#services" className="hover:text-white transition-colors">Corporate Office Cleaning</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Deep Office Cleaning</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Glass & Facade Cleaning</a></li>
                <li><a href="#services" className="hover:text-white transition-colors">Floor Scrubbing & Polishing</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Dispatch & Office</h4>
              <p className="text-xs text-slate-400 leading-relaxed mb-3">
                {ADDRESS}
              </p>
              <p className="text-xs font-mono text-red-400">
                WhatsApp: +91 96861 71995
              </p>
            </div>

          </div>

          <div className="border-t border-slate-900 pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500">
            <p>© {new Date().getFullYear()} NEXA Commercial & Corporate Cleaning Services Bangalore. All rights reserved.</p>
            <div className="flex gap-6 mt-4 sm:mt-0">
              <span className="text-slate-400">Primary WhatsApp: +91 96861 71995</span>
            </div>
          </div>
        </div>
      </footer>

      {/* FLOATING WHATSAPP BUTTON */}
      <aside aria-label="WhatsApp Support">
        <a
          href={`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=Hello%20NEXA,%20I%20would%20like%20to%20enquire%20about%20corporate%20cleaning%20services.`}
          target="_blank"
          rel="noreferrer"
          className="fixed bottom-6 right-6 z-50 bg-emerald-600 hover:bg-emerald-500 text-white p-4 rounded-full shadow-[0_4px_25px_rgba(16,185,129,0.5)] flex items-center justify-center transform hover:scale-110 transition-all duration-300 group"
          data-testid="floating-whatsapp-btn"
          title="Chat with NEXA on WhatsApp"
        >
          <MessageSquare className="w-7 h-7 fill-white" />
          <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs group-hover:ml-2 transition-all duration-300 font-bold text-sm">
            Chat on WhatsApp
          </span>
        </a>
      </aside>

      {/* BOOKING / WHATSAPP REDIRECT MODAL */}
      <AnimatePresence>
        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="bg-slate-900 border border-slate-800 rounded-2xl max-w-lg w-full p-6 sm:p-8 shadow-2xl relative"
              data-testid="whatsapp-booking-modal"
            >
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-slate-400 hover:text-white p-2 rounded-lg bg-slate-800/50"
                data-testid="close-modal-btn"
              >
                <X className="w-5 h-5" />
              </button>

              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-red-600/20 border border-red-500/40 flex items-center justify-center text-red-500">
                  <MessageSquare className="w-6 h-6 fill-red-500" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">Book via WhatsApp</h3>
                  <p className="text-xs text-slate-400">Instantly connects to +91 96861 71995</p>
                </div>
              </div>

              {/* Selected Service Badge */}
              {activeService && (
                <div className="bg-slate-950 p-4 rounded-xl border border-slate-800 mb-6 flex items-center gap-4">
                  <img src={activeService.image} alt={activeService.title} className="w-16 h-16 rounded-lg object-cover" />
                  <div>
                    <span className="text-[10px] font-bold text-red-400 uppercase tracking-wider">{activeService.category}</span>
                    <h4 className="text-sm font-bold text-white">{activeService.title}</h4>
                  </div>
                </div>
              )}

              <form onSubmit={handleWhatsAppSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">Your Name *</label>
                  <input 
                    type="text" 
                    placeholder="Enter your name"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-red-500"
                    data-testid="modal-customer-name"
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">WhatsApp Phone Number *</label>
                  <input 
                    type="tel" 
                    placeholder="+91 98765 43210"
                    value={customerPhone}
                    onChange={(e) => setCustomerPhone(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-red-500"
                    data-testid="modal-customer-phone"
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">Preferred Date *</label>
                  <input 
                    type="date" 
                    value={preferredDate}
                    onChange={(e) => setPreferredDate(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-red-500"
                    data-testid="modal-preferred-date"
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">Property Size / Scope</label>
                  <select
                    value={propertySize}
                    onChange={(e) => setPropertySize(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-red-500"
                    data-testid="modal-property-size"
                  >
                    <option value="Small Office / Cabin (< 2,000 sq.ft)">Small Office / Cabin (&lt; 2,000 sq.ft)</option>
                    <option value="Medium Office (2,000 - 5,000 sq.ft)">Medium Office (2,000 - 5,000 sq.ft)</option>
                    <option value="Large Office / IT Park Floor (5,000+ sq.ft)">Large Office / IT Park Floor (5,000+ sq.ft)</option>
                    <option value="Commercial Building / Warehouse">Commercial Building / Warehouse</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-slate-300 mb-1">Additional Notes (Optional)</label>
                  <textarea 
                    placeholder="Any specific cleaning instructions..."
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    rows={2}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-red-500 resize-none"
                    data-testid="modal-notes"
                  />
                </div>

                <div className="pt-2">
                  <button
                    type="submit"
                    className="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-3.5 rounded-xl shadow-[0_4px_25px_rgba(220,38,38,0.5)] transition-all flex items-center justify-center gap-2"
                    data-testid="modal-submit-whatsapp-btn"
                  >
                    <MessageSquare className="w-5 h-5 fill-white" />
                    <span>Open WhatsApp & Send Enquiry</span>
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

    </div>
  );
}
